module.exports = __webpack_public_path__ + "img/Man_made_material.12cfd22e.png";